import React, { useState, useContext, useEffect } from "react";
import {
  // List,
  // Search,
  // DollarSign,
  Calendar,
  ChevronsLeft,
  Monitor,
  Folder
} from "react-feather";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
// import logo from "../../../../assets/images/buscar-logo-light.png";
// import smallLogo from "../../../../assets/images/buscar-logo-square.png";
import logo from "../../../../assets/images/tcr-logo-light.png";
import smallLogo from "../../../../assets/images/tcr-logo-square.png";
import terrasLogo from "../../../../assets/images/terras-logo-light.png";
import banrisulLogo from "../../../../assets/images/banrisul-novo-logo.png";
import UserContext from "./../../../../context/UserContext";
import { trackPageView } from "./../../../../utils/analytics";
import { getJwtData, hasAccessToDashboard } from "./../../../../api";
import "./styles.scss";

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [hasDashboardAccess, setHasDashboardAccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const location = useLocation();
  const { formatMessage } = useIntl();

  const userData = useContext(UserContext);

  const history = useHistory();

  useEffect(() => {
    const hasAccessStorage = localStorage.getItem("@BusCAR/dashboard-access");

    if (hasAccessStorage === "false") {
      return () => {};
    }

    if (hasAccessStorage === "true") {
      setHasDashboardAccess(true);
      return () => {};
    }

    if (!hasAccessStorage) {
      hasAccessToDashboard()
        .then(({ data }) => {
          if (data.acesso) {
            localStorage.setItem("@BusCAR/dashboard-access", true);
            setHasDashboardAccess(true);
          } else {
            throw Error;
          }
        })
        .catch(() => {
          setHasDashboardAccess(false);
          localStorage.setItem("@BusCAR/dashboard-access", false);
        });
      return () => {};
    }

    return () => {};
  }, [hasDashboardAccess]);

  const calculateTimeLeft = () => {
    const jwtData = getJwtData();

    const exp = String(jwtData.exp);
    const dateToExpire = new Date(exp.slice(0, -3) * 1e3);
    const difference = dateToExpire - +new Date();

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  const onLogout = () => {
    trackPageView("/logout");
    localStorage.removeItem("access_token");
    localStorage.removeItem("@BusCAR/dashboard-access");
    localStorage.removeItem("@BusCAR:ambient");
    history.push("/login");
  };

  const onRefresh = () => {
    window.location.reload(true);
  };

  return (
    <section id="navigation" className={open ? "open" : ""}>
      <ChevronsLeft
        className="collapse-button"
        onClick={() => setOpen(!open)}
        size={32}
      />
      <div className="navigation-brand">
        <a href="/">
          <img className="large-logo" src={logo} alt="BusCAR logo" />
        </a>
        <a href="/">
          <img className="small-logo" src={smallLogo} alt="BusCAR logo" />
        </a>
      </div>
      <ul className="page-links">
        {/* <li>
          <Link
            to="/new-analysis"
            className={location.pathname === "/new-analysis" ? "active" : ""}
          >
            <Search className="page-icon" />{" "}
            {formatMessage({ id: "nova-consulta" })}
          </Link>
        </li> */}
        <li>
          <Link
            to="/operations"
            className={location.pathname === "/operations" ? "active" : ""}
          >
            <Folder className="page-icon" /> {formatMessage({ id: "operacao" })}
          </Link>
        </li>
        <li>
          <Link
            to="/history"
            className={location.pathname === "/history" ? "active" : ""}
          >
            <Calendar className="page-icon" />{" "}
            {formatMessage({ id: "historico" })}
          </Link>
        </li>
        {hasDashboardAccess && (
          <li>
            <Link
              to="/dashboard"
              className={location.pathname === "/dashboard" ? "active" : ""}
            >
              <Monitor className="page-icon" /> Dashboard
            </Link>
          </li>
        )}
      </ul>

      <ul
        className={`auth-item language-options ${
          open ? "clear-media-query" : ""
        }`}
      >
        <li>
          <a
            href="#/"
            data-testid="-br"
            onClick={() => userData.storeLang("pt-BR")}
          >
            <span className="flag-icon flag-icon-br"></span>
          </a>
        </li>
        <li>
          <a
            href="#/"
            data-testid="-us"
            onClick={() => userData.storeLang("en-US")}
          >
            <span className="flag-icon flag-icon-us"></span>
          </a>
        </li>
      </ul>

      <p className="session-timeleft">
        Tempo restante de sessão:
        <br />
        <span>
          {timeLeft.days > 0 &&
            `${timeLeft.days} ${formatMessage({ id: "dias" })}, `}
          {timeLeft.hours > 0 &&
            `${timeLeft.hours} ${formatMessage({ id: "horas" })}, `}
          {timeLeft.minutes > 0 &&
            `${timeLeft.minutes} ${formatMessage({ id: "minutos" })}${
              !timeLeft.days && !timeLeft.hours ? "," : ""
            }`}
          {timeLeft.days === 0 &&
            timeLeft.hours === 0 &&
            ` ${timeLeft.seconds} ${formatMessage({ id: "segundos" })}`}
        </span>
      </p>

      <div className="navigation-footer">
        <ul>
          <li>
            <Link to="/about">{formatMessage({ id: "sobre" })}</Link>
          </li>
          <li>
            <Link to="/manual">Manual</Link>
          </li>
          <li>
            <Link to="/terms-of-use">
              {formatMessage({ id: "termos-uso" })}
            </Link>
          </li>
          <li>
            <Link to="/privacy-policy">
              {formatMessage({ id: "politica-privacidade" })}
            </Link>
          </li>
          <li>
            <a
              href="/swagger/tcr.html#/"
              target="_blank"
              rel="noopener noreferrer"
            >
              API
            </a>
          </li>
          <li>
            <Link to="/contact">{formatMessage({ id: "contato" })}</Link>
          </li>
          {/* TODO: Remove once user section has been implemented */}
          <li>
            <Link to="/change-password">
              {formatMessage({ id: "alterar-senha" })}
            </Link>
          </li>
          <li>
            <button className="link-button" onClick={onLogout}>
              {formatMessage({ id: "sair" })}
            </button>
          </li>
        </ul>
        <div className="powered-by">
          <img src={terrasLogo} alt="Terras logo" className="terras-logo" />
          <img
            src={banrisulLogo}
            alt="Banrisul logo"
            className="banrisul-logo"
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <button className="link-button" onClick={onRefresh}>
            Versão: {process.env.REACT_APP_GIT_REV}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Navigation;
